export const getProductPrice = (product) => {
  const requiredQty = product.required_qty || 1;

  for (let i = 0; i < product.price.price_list.length; i++) {
    const priceSlab = product.price.price_list[i];
    if (priceSlab.min_qty <= requiredQty) return priceSlab.price;
  }
  return 0;
};

export const formatPrice = (price, decimals = 2) => {
  return price.toFixed(decimals);
};

export const getCartTotal = (cart, promoCode = null) => {
  let subTotal = 0;
  for (let i = 0; i < cart.length; i++) {
    const price = getProductPrice(cart[i]);
    subTotal += parseFloat(cart[i].required_qty * price);
  }

  let discount = 0;
  let totalAfterDiscount = parseFloat(subTotal);
  
  // Apply promo code discount if available
  if (promoCode) {
    if (promoCode.type === 1) {
      discount = parseFloat(promoCode.code_value);
    } else if (promoCode.type === 2) {
      discount = (parseFloat(promoCode.code_value) / 100) * subTotal;
    }
    // Ensure discount doesn't exceed the subtotal
    discount = Math.min(discount, subTotal);
    totalAfterDiscount = subTotal - discount;
  }

  subTotal = formatPrice(subTotal);
  const gst = formatPrice((totalAfterDiscount * 18) / 100);
  const total = formatPrice(parseFloat(totalAfterDiscount) + parseFloat(gst));

  return { 
    subTotal, 
    total, 
    gst,
    discount: formatPrice(discount),
    hasPromo: !!promoCode,
    promoCode: promoCode ? promoCode.code : null
  };
};
